import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import styles from './JoinNow.module.sass';
import Button from '../../../ui_kit/button/Button';
import { userObjectSelector } from '../../../user/selectors/user';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';

class JoinNow extends Component {
  signUp = () => {
    const { signUp } = this.props;
    Cookies.set('signed_up_from', 'join_us');
    signUp();
  };

  render() {
    const { user } = this.props;

    return (
      <div className={styles['join-now-container']}>
        <div className={styles.image} />
        {user && (
          <>
            <div className={styles['join-now-header']}>
              Check out our loyalty program The Lounge for
              <br />
              exclusive discounts, free products and more.
            </div>
            <div className={styles['button-container']}>
              <Button
                size="small"
                text="GO TO THE LOUNGE"
                color="transparent-blue"
                className={styles.button}
                href="/pages/the_lounge/"
              />
            </div>
          </>
        )}
        {!user && (
          <>
            <div className={styles['join-now-header']}>
              Join us for 15% off your next order plus
              <br />
              exclusive discounts and announcements.
            </div>
            <div className={styles['button-container']}>
              <Button
                size="small"
                text="SIGN UP"
                color="transparent-blue"
                className={styles.button}
                onClickHandler={this.signUp}
              />
            </div>
          </>
        )}
      </div>
    );
  }
}

JoinNow.propTypes = {
  user: PropTypes.shape({}),
  signUp: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  signUp: () => dispatch(modalsActions.openModalRequest({ modal: MODALS.SIGN_UP })),
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinNow);
